
<template>
  <v-container class="grey-lighten-3 full-height">
      <v-row justify="center">
          <v-col cols="12" xl="10" lg="11" md="12">
              <v-sheet class="report-paper pa-5 mx-auto" elevation="3" id="printable-area">

              <div class="header-section d-flex justify-space-between mb-6 lines">
                  <div class="company-logo-area d-flex align-center">
                      <div class="logo-placeholder mr-4">
                      </div>
                      <div>
                          <v-img
                          :src="`${getFileServerUrl.replace(/\/$/, '')}/${getCurrentCompany?.logo_thumb || 'uploads/demo_images/user.png'}`"
                          width="200" height="100" class="rounded" />
                      </div>
                  </div>

                  <div class="company-address text-caption text-right">
                      <h1 class="company-name text-h5 font-weight-bold text-uppercase">
                          {{ companyInfo.name }}
                      </h1>
                      <h1 class="text-subtitle-1 text-end">
                          {{ companyInfo.address }}
                      </h1>
                  </div>
              </div>

              <!-- Title -->
              <div class="text-center mb-6">
                  <h2 class="report-title text-h6 font-weight-bold text-decoration-underline">
                      TAX INVOICE
                  </h2>
              </div>

              <!-- Master Information -->
              <div class="meta-info-box mb-4">
                  <div class="d-flex">
                      <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000; border-bottom:1px solid #000">
                          <span class="meta-label pl-2">Invoice Code:</span>
                          <span class="meta-value pl-2 font-weight-bold">{{ saleInvoice?.code }}</span>
                      </div>  
                      <div class="meta-item d-flex align-center" style="width: 50%; border-bottom:1px solid #000">
                          <span class="meta-label pl-2">Invoice Date:</span>
                          <span class="meta-value pl-2">{{ saleInvoice?.sale_invoice_date }}</span>
                      </div>
                  </div>
                  <div class="d-flex" style="border-bottom: 1px solid #000;">
                      <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                          <span class="meta-label pl-2">Buyer Name:</span>
                          <span class="meta-value pl-2">{{ saleInvoice?.customer?.customer_name }}</span>
                      </div>
                      <div class="meta-item d-flex align-center" style="width: 50%;">
                          <span class="meta-label pl-2">Shipper Name:</span>
                          <span class="meta-value pl-2">{{ saleInvoice?.supplier?.customer_name  }}</span>
                      </div>
                  </div>
                  <div class="d-flex" style="border-bottom: 1px solid #000;">
                      <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                          <span class="meta-label pl-2">Container No:</span>
                          <span class="meta-value pl-2">{{ saleInvoice?.container_no }}</span>
                      </div>
                      <div class="meta-item d-flex align-center" style="width: 50%;">
                          <span class="meta-label pl-2">MBL NO: </span>
                          <span class="meta-value pl-2">{{ saleInvoice?.mbl_no }}</span>
                      </div>
                  </div>
                  <div class="d-flex">
                      <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                          <span class="meta-label pl-2">HBL NO:</span>
                          <span class="meta-value pl-2">{{ saleInvoice?.hbl_no }}</span>
                      </div>
                      <div class="meta-item d-flex align-center" style="width: 50%;">
                          <span class="meta-label pl-2">MBL / HBL Date:</span>
                          <span class="meta-value pl-2">{{ saleInvoice?.mbl_date }}</span>
                      </div>
                  </div>
              </div>

              <!-- Depreciation Details Table -->
              <div class="table-container mb-6">
                  <table class="dep-table">
                      <thead>
                          <tr>
                              <th class="text-center" style="width: 40px;">SL</th>
                              <th>Product Name</th>
                              <th>Category</th>
                              <th>Calc. Type</th>
                              <!-- <th>Height</th>
                              <th>Length</th>
                              <th>Width</th> -->
                              <th>CBM Meas.</th>
                              <th>CBM</th>
                              <th>Qty</th>
                              <th>Rate</th>
                              <th>Amount</th>
                              <th>Remarks</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(detail, index) in cart" :key="detail.id">
                              <td class="text-center">{{ index + 1 }}</td>
                              <td class="text-left">{{ detail.product_name }}</td>
                              <td class="text-left">{{ categoryLabel(detail.category) }}</td>
                              <td class="text-left">{{ calTypeLabel(detail.calc_type) }}</td>
                              <!-- <td class="text-right">{{ detail.height }}</td>
                              <td class="text-right">{{ detail.length }}</td>
                              <td class="text-right">{{ detail.width }}</td> -->
                              <td class="text-right">{{ detail.cbm_meas }}</td>
                              <td class="text-right">{{ detail.cbm }}</td>
                              <td class="text-right">{{ detail.qty }}</td>
                              <td class="text-right">{{ detail.rate }}</td>
                              <td class="text-right">{{ detail.total }}</td>
                              <td class="text-left">{{ detail.remarks }}</td>
                          </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <th colspan="4" class="text-center">TOTAL</th>
                        <th></th>
                        <th></th>
                        <th class="text-right">{{ cart.reduce((prev, cur) => { return +prev + +cur.qty }, 0) ?? 0 }}</th>
                        <th></th>
                        <th class="text-right">{{ parseFloat(cart.reduce((prev, cur) => { return +prev + +cur.total }, 0) ?? 0).toFixed(2) }}</th>
                        <th></th>
                      </tr>
                    </tfoot>
                  </table>
              </div>

              <v-row class="mt-16">
                  <v-col cols="4">
                  <p style="border-top: 1px solid #555; width:200px; margin: 0 auto; color: #333; text-align:center">
                      <span>Received By</span>
                  </p>
                  </v-col>
                  <v-col cols="4"></v-col>
                  <v-col cols="4">
                  <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                      <span>Send By</span>
                  </p>
                  </v-col>
              </v-row>

              <v-row>
                  <v-col cols="12" class="text-center mt-4">
                      <span class="text-caption">
                          <hr>
                        UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai. 
                        <br>
                          Cell: +971 507155639& +971 566491905
                          <br>
                          Dhaka Office: House Name: Sahnaz Sultana house no: 14 Road no: 32 Lift: 6-a Gulshan-1, Dhaka-1212 , Bnagladesh. 
                        <br> Cell: +88 01898461015& +88 01330456380
                    </span>
                  </v-col>
              </v-row>


              </v-sheet>
          </v-col>
      </v-row>
        <!-- Action Toolbar (Hidden on Print) -->
      <v-row class="d-print-none mb-4" justify="center">
          <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
              <!-- <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                  Print PDF
              </v-btn> -->
              <v-btn color="success" prepend-icon="mdi-download" @click="printInvoice">
                  Print PDF
              </v-btn>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import formatDateView from "@/plugins/dateFormatView";
import { shipModeLabel, payModeLabel, categoryLabel, calTypeLabel } from "@/plugins/helpers.js";
import { prefix } from "@/store/api";
import Axios from "axios";
export default {
  data() {
    return {
      showPrintPreview: false,
      sale_order_master_id: '',
      code: '',
      sale_order_date: '',
      delivery_address: '',
      description: '',
      previous_due: '',
      due: '',
      paid: '',
      payment_terms: '',
      ref_no: '',
      discount_amount: '',
      tax_type: '',
      tax_amount: '',
      vat_type: '',
      vat_amount: '',
      sub_total: '',
      total: '',
      saleInvoice: '',
      companyInfo: {
        name: "",
        mobile: "",
        address: "",
        email: "",
        code: '',
        bin_no: '',
        tin_no: '',
        group_head_ind: '',
        logo: '',
        logo_thumb: '',
        website: ''
      },
      customer: {
        company_name: '',
        code: '',
        company_owner_name: '',
        company_mobile: '',
        company_email: '',
        company_address: '',
      },
      supplier: {
        company_name: '',
        code: '',
        company_owner_name: '',
        company_mobile: '',
        company_email: '',
        company_address: '',
      },
      cart: [],
      prefix: prefix
    };
  },
  methods: {
    categoryLabel,
    calTypeLabel,
    convertNumberToWords,
    formatDateView,

    async downloadInvoice(id) {
      // const token = localStorage.getItem("token");
      try {
        const response = await Axios.get(`${prefix}sales/make-so-invoice-pdf/${id}`, {
          responseType: "blob",
          // headers: {
          //   Authorization: `Bearer ${token}`,
          // },
        });

        // Create URL and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // window.open(url, "_blank");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoice-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    async printInvoice() {
      const totalQty = (this.cart || []).reduce((s, p) => s + (+p.qty || 0), 0);
      const totalProductQty = (this.cart || []).reduce((s, p) => s + (+p.product_qty || 0), 0);
      const totalAmount = (this.cart || []).reduce((s, p) => s + (+p.total || 0), 0);

      // helper to escape HTML text (simple)
      const esc = (val) => (val === null || val === undefined) ? '' : String(val).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');

      const logoSrc = this.getCurrentCompany?.logo_thumb
        ? `${this.getFileServerUrl.replace(/\/$/, '')}/${this.getCurrentCompany.logo_thumb}`
        : `${this.getFileServerUrl.replace(/\/$/, '')}/uploads/demo_images/user.png`;

      const html = `
        <!doctype html>
          <html>
          <head>
            <meta charset="utf-8"/>
            <meta name="viewport" content="width=device-width,initial-scale=1"/>
            <title>Tax Invoice - ${esc(this.saleInvoice?.code)}</title>

            <!-- Bootstrap CSS -->
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet"/>

            <style>
              body { font-family: Arial, Helvetica, sans-serif; margin: 0; color: #111; }
              .paper { max-width: 280mm; margin: 10px auto; background: #fff; padding: 18px; box-sizing: border-box; }
              .company-logo img { max-width: 200px; height: auto; }
              .meta-box { border: 1px solid #000; padding: 0; overflow: hidden; }
              .meta-row { display: flex; width: 100%; }
              .meta-cell { flex: 1; padding: 8px; border-right: 1px solid #000; border-bottom:1px solid #000; box-sizing: border-box; height: 40px; display:flex; align-items:center; }
              .meta-cell:last-child { border-right: none; }
              table.invoice-table { width: 100%; border-collapse: collapse; font-size: 13px; margin-top: 12px; }
              table.invoice-table th, table.invoice-table td { border: 1px solid #000; padding: 6px 8px; vertical-align: top; }
              table.invoice-table th { background: #f0f0f0; }
              .totals { margin-top: 12px; }
              .signature { margin-top: 36px; display:flex; justify-content:space-between; align-items:center; }
              .sig-line { width: 200px; border-top: 1px solid #555; text-align:center; padding-top:6px; }
              .watermark {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-image: url('${this.getCurrentCompany.logo_thumb ? this.getFileServerUrl + this.getCurrentCompany.logo_thumb : '@/assets/image/logo.png'}');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                width: 80%; 
                height: 80%;
                opacity: 0.1;
                z-index: 999;
                pointer-events: none;
              }
              @media print {
                body * { visibility: hidden; }
                #printable, #printable * { visibility: visible; }
                #printable { position: absolute; left: 0; top: 0; width: 100%; padding: 8px; }
                @page { size: A4 portrait; margin: 0.5cm; }
              }
            </style>
          </head>
          <body>
            <div id="printable" class="paper position-relative">
              <div class="watermark"></div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="company-logo text-end company-logo">
                  <img src="${logoSrc}" alt="Logo" class="img-fluid" />
                </div>
                <div>
                  <h5 class="mb-0 text-uppercase text-end">${esc(this.getCurrentCompany?.name || this.companyInfo?.name || '')}</h5>
                  <p class="mb-0 text-end" style="font-size:14px">${esc(this.getCurrentCompany?.address || this.companyInfo?.address || '')}</p>
                </div>
                
              </div>

              <h6 class="text-center mb-3"><strong>TAX INVOICE</strong></h6>

              <!-- Meta info -->
              <div class="meta-box mb-2">
                <div class="meta-row">
                  <div class="meta-cell"><strong class="me-2">Invoice Code:</strong> ${esc(this.saleInvoice?.code || '')}</div>
                  <div class="meta-cell"><strong class="me-2">Invoice Date:</strong> ${esc(this.saleInvoice?.sale_invoice_date || '')}</div>
                </div>
                <div class="meta-row">
                  <div class="meta-cell"><strong class="me-2">Buyer Name:</strong> ${esc(this.saleInvoice?.customer?.customer_name || '')}</div>
                  <div class="meta-cell"><strong class="me-2">Shipper Name:</strong> ${esc(this.saleInvoice?.supplier?.customer_name || '')}</div>
                </div>
                <div class="meta-row">
                  <div class="meta-cell"><strong class="me-2">Container No:</strong> ${esc(this.saleInvoice?.container_no || '')}</div>
                  <div class="meta-cell"><strong class="me-2">MBL NO:</strong> ${esc(this.saleInvoice?.mbl_no || '-')}</div>
                </div>
                <div class="meta-row">
                  <div class="meta-cell" style="border-bottom:none"><strong class="me-2">HBL No:</strong> ${esc(this.saleInvoice?.hbl_no || '')}</div>
                  <div class="meta-cell" style="border-bottom:none"><strong class="me-2">MBL / HBL Date:</strong> ${esc(this.saleInvoice?.mbl_date || '')}</div>
                </div>
              </div>

              <!-- Table -->
              <div class="table-responsive">
                <table class="invoice-table">
                  <thead>
                    <tr>
                      <th style="width:40px;">SL</th>
                      <th>Product Name</th>
                      <th>Category</th>
                      <th>Calc. Type</th>
                      <th>CBM Meas.</th>
                      <th>CBM</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>Amount</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${ (this.cart || []).map((detail, idx) => `
                      <tr>
                        <td class="text-center">${idx + 1}</td>
                        <td>${esc(detail.product_name || '')}</td>
                        <td class="text-center">${esc(categoryLabel(detail.category) || '')}</td>
                        <td class="text-center">${esc(calTypeLabel(detail.calc_type) || '')}</td>
                        <td class="text-end">${(detail.cbm_meas !== undefined ? detail.cbm_meas : '')}</td>
                        <td class="text-end">${(detail.cbm !== undefined ? detail.cbm : '')}</td>
                        <td class="text-end">${(+detail.qty || 0).toLocaleString()}</td>
                        <td class="text-end">${(detail.rate !== undefined ? (+detail.rate).toFixed(2) : '')}</td>
                        <td class="text-end">${(+detail.total || 0).toFixed(2)}</td>
                        <td class="text-center">${esc(detail.remarks || '')}</td>
                      </tr>
                    `).join('')}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="4" class="text-center">TOTAL</th>
                      <th></th>
                      <th></th>
                      <th class="text-end">${totalQty.toLocaleString()}</th>
                      <th></th>
                      <th class="text-end">${totalAmount.toFixed(2)}</th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div class="signature">
                <div class="text-center">
                  <div class="sig-line">Received By</div>
                </div>
                <div></div>
                <div class="text-center">
                  <div class="sig-line">Send By</div>
                </div>
              </div>

              <div class="text-center mt-3 small">
                <hr/>
                <div>
                  UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai.
                  <br> Cell: +971 507155639 &amp; +971 566491905
                  <br> Dhaka Office: House Name: Sahnaz Sultana house no: 14 Road no: 32 Lift: 6-a Gulshan-1, Dhaka-1212 , Bangladesh.
                  <br> Cell: +88 01898461015 &amp; +88 01330456380
                </div>
              </div>

            </div>
          </body>
          </html>
        `;

      const printWindow = window.open('', 'PRINT', `width=${screen.width},height=${screen.height},left=0,top=0`);
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        await new Promise(resolve => {
          const imgs = printWindow.document.images;
          if (!imgs || imgs.length === 0) return resolve();
          let loaded = 0;
          for (let i = 0; i < imgs.length; i++) {
            imgs[i].onload = imgs[i].onerror = () => {
              loaded++;
              if (loaded === imgs.length) resolve();
            };
          }
        });

      await new Promise(r => setTimeout(r, 500));
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  },
  computed: {
    getCurrentCompany() {
      this.companyInfo = this.$store.getters.getCurrentCompany;
      return this.$store.getters.getCurrentCompany;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.$nextTick(() => {
        this.$store
          .dispatch("getSaleInvoiceById", id)
          .then((data) => {
              let saleInvoice = data;
              this.saleInvoice = data;
              this.sale_order_master_id = saleInvoice.id
              this.code = saleInvoice.code
              this.container = saleInvoice.container
              this.hbl_date = saleInvoice.hbl_date
              this.mbl_date = saleInvoice.mbl_date
              this.sale_invoice_date = saleInvoice.sale_invoice_date
              this.description = saleInvoice.description
              this.due = saleInvoice.due
              this.paid = saleInvoice.paid
              this.discount_amount = saleInvoice.discount_amount
              this.tax_type = saleInvoice.tax_type
              this.tax_amount = saleInvoice.tax_amount
              this.vat_type = saleInvoice.vat_type
              this.vat_amount = saleInvoice.vat_amount
              this.sub_total = saleInvoice.sub_total
              this.total = saleInvoice.total

              this.customer = {
                customer_name: saleInvoice.customer?.customer_name || "",
                code: saleInvoice.customer?.code || "",
                customer_owner_name: saleInvoice.customer?.customer_owner_name || "",
                customer_mobile: saleInvoice.customer?.customer_mobile || "",
                customer_email: saleInvoice.customer?.customer_email || "",
                customer_address: saleInvoice.customer?.customer_address || "",
                logo: saleInvoice.customer?.logo || "",
                logo_thumb: saleInvoice.customer?.logo_thumb || "",
                customer_website: saleInvoice.customer?.customer_website || ""
              };
              this.supplier = {
                customer_name: saleInvoice.customer?.customer_name || "",
                code: saleInvoice.customer?.code || "",
                customer_owner_name: saleInvoice.customer?.customer_owner_name || "",
                customer_mobile: saleInvoice.customer?.customer_mobile || "",
                customer_email: saleInvoice.customer?.customer_email || "",
                customer_address: saleInvoice.customer?.customer_address || "",
                logo: saleInvoice.customer?.logo || "",
                logo_thumb: saleInvoice.customer?.logo_thumb || "",
                customer_website: saleInvoice.customer?.customer_website || ""
              };

              this.cart = [];
              (saleInvoice.details || []).forEach((item) => {
                  this.cart.push({
                    product_id: item?.product?.id,
                    product_name: item?.product?.name || "",
                    product_code: item?.product.code || "",
                    calc_type: item?.sale_order_details?.calc_type || "",
                    category: item?.sale_order_details?.category || "",
                    height: item?.sale_order_details?.height || "",
                    length: item?.sale_order_details?.length || "",
                    width: item?.sale_order_details?.width || "",
                    cbm: item?.sale_order_details?.cbm || "",
                    cbm_meas: item?.sale_order_details?.cbm_meas || "",
                    qty: item.qty,
                    product_qty: item.product_qty,
                    rate: item.sale_rate || "",
                    total: item.total,
                  });
              });
              console.log(this.cart)
          })
          .catch((error) => {
            console.error("Failed to fetch sale order:", error);
          });
      });
    }
  }
};
</script>

<style scoped>
.header-section {
    display: flex;
    flex-direction: flex !important;
}
/* .company-address {
    text-align: left !important;
} */
.full-height {
    min-height: 100vh;
}
.grey-lighten-3 {
    background-color: #eeeeee !important;
}
.report-paper {
    background-color: white;
    color: black;
    font-family: 'Times New Roman', serif;
    max-width: 280mm;
    width: 100%;
    min-height: 297mm;
}
.company-name {
    color: #444;
    letter-spacing: 1px;
}
.report-title {
    text-decoration: underline;
    text-underline-offset: 4px;
}
.meta-info-box {
    border: 1px solid #000;
}
.meta-item {
    height: 35px;
}
.meta-label {
    font-weight: 500;
    color: #333;
}
.dep-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.dep-table th {
    background-color: #e0e0e0;
    border: 1px solid #000;
    padding: 6px 5px;
}
.dep-table td {
    border: 1px solid #000;
    padding: 6px 5px;
    vertical-align: top;
}
.lines {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.gap-2 {
    gap: 8px;
}

/* Print Styles */
@media print {
    body * {
        visibility: hidden;
    }
    #printable-area,
    #printable-area * {
            visibility: visible;
    }
    #printable-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 15px;
    }
    .report-paper {
        box-shadow: none !important;
    }
    @page {
        size: A4 portrait;
        margin: 0.5cm;
    }
    .d-print-none {
        display: none !important;
    }
}

</style>
